(() => {
  const filterKeys = [
    'filter.v.price.gte',
    'filter.v.price.lte',
    'filter.p.m.custom.age_group',
    'filter.p.m.custom.gender',
    'filter.v.availability'
  ];
  const priceKeys = filterKeys.slice(0, 2);
  const collectionPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/([^/]+)\/?$/i;
  let refreshScheduled = false;

  function refreshLinks() {
    const current = new URL(window.location.href);
    const carried = current.searchParams;
    if (!filterKeys.some((key) => carried.has(key)) &&
        !document.querySelector('a[data-filter-original-href]')) return;

    const currentPath = current.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/collections\/)/i, '').replace(/\/$/, '');

    document.querySelectorAll('a[href]').forEach((link) => {
      // Clear-all links must stay plain so a new tab or a JS failure still clears the filters.
      // So must the URL filter pills, which each drop one carried value.
      if (link.classList.contains('filters-form_remove-all') || link.hasAttribute('data-filter-url-pill')) return;
      const href = link.getAttribute('href');
      // Store both hrefs on the link so cloned links can restore the plain URL.
      const original = href === link.dataset.filterRenderedHref
        ? link.dataset.filterOriginalHref : href;
      let target;

      try {
        target = new URL(original, current);
      } catch (error) {
        return;
      }

      if (target.origin !== current.origin || !collectionPath.test(target.pathname)) return;
      const handle = target.pathname.match(collectionPath)[1];
      if (['vendors', 'types'].includes(handle.toLowerCase())) return;
      const targetPath = target.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/collections\/)/i, '').replace(/\/$/, '');
      if (targetPath === currentPath && !target.search) return;

      const originalSearch = target.search;
      // A link that sets either price bound owns the whole price range.
      const hasOwnPrice = priceKeys.some((key) => target.searchParams.has(key));
      // All products hides sold-out products and has no availability filter to undo it.
      const hidesSoldOut = handle.toLowerCase() === 'all';
      filterKeys.forEach((key) => {
        if (!carried.has(key) || target.searchParams.has(key) ||
            (hasOwnPrice && priceKeys.includes(key))) return;

        carried.getAll(key).forEach((value) => {
          if (hidesSoldOut && key === 'filter.v.availability' && value === '0') return;
          target.searchParams.append(key, value);
        });
      });

      const updated = target.search === originalSearch
        ? original
        : `${target.pathname}${target.search}${target.hash}`;
      if (href !== updated) link.setAttribute('href', updated);
      if (updated === original) {
        delete link.dataset.filterOriginalHref;
        delete link.dataset.filterRenderedHref;
      } else {
        link.dataset.filterOriginalHref = original;
        link.dataset.filterRenderedHref = updated;
      }
    });
  }

  function scheduleRefresh() {
    if (refreshScheduled) return;
    refreshScheduled = true;
    requestAnimationFrame(() => {
      refreshScheduled = false;
      refreshLinks();
    });
  }

  ['pushState', 'replaceState'].forEach((method) => {
    const original = history[method];
    history[method] = function(...args) {
      const result = original.apply(this, args);
      refreshLinks();
      return result;
    };
  });

  window.addEventListener('popstate', refreshLinks);
  new MutationObserver((records) => {
    if (records.some((record) => record.type === 'attributes' ||
        Array.from(record.addedNodes).some((node) => node.nodeType === Node.ELEMENT_NODE))) {
      scheduleRefresh();
    }
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href']
  });
  refreshLinks();
})();
